import { render, staticRenderFns } from "./MenuItemModal.vue?vue&type=template&id=3587fc38&"
import script from "./MenuItemModal.vue?vue&type=script&lang=js&"
export * from "./MenuItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports